import { render } from "./MessaggioStandard.vue?vue&type=template&id=3f60f215"
import script from "./MessaggioStandard.vue?vue&type=script&lang=js"
export * from "./MessaggioStandard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\diego\\source\\repos\\PoligeoDocumenti\\PoligeoDocumenti\\poligeo-documenti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__